/** @format */

import React from 'react'

import { Collapse, Alert } from 'antd'

import Recipe from '../../../../../components/Recipe'

import './style.css'

export default function Products(props) {
	return (
		<div className='ph-tracking-detail-products-global-container'>
			<h1 className='ph-tracking-detail-products-title'>Información de Productos</h1>
			{props.products.map((product) => {
				return (
					<div
						className='ph-tracking-detail-products-main-container'
						key={product.id || product.objectID}>
						<div className='ph-tracking-detail-products-inner-container'>
							<div>
								<img
									src={product.image}
									className='ph-tracking-detail-products-img'
									alt='producto'></img>
							</div>
							<div className='ph-tracking-detail-products-inner-contain'>
								<div className='ph-tracking-detail-products-name-recipe'>
									<a
										href={`https://www.pharol.cl/products/${product.slug}`}
										target='_blank'
										rel='noopener noreferrer'>
										<h1 className='ph-tracking-detail-products-img-prod-title'>
											{product.meta_title}
										</h1>
									</a>
									{product.recipe && props.status !== 101 && (
										<Recipe
											product={product}
											status={props.status}
											pharmacy={props.pharmacy}
											order={props.order}
											invalidRecipeReasons={props.invalidRecipeReasons}
											handleAcceptOrRejectRecipe={props.handleAcceptOrRejectRecipe}
											handleEditRutOrRecipe={props.handleEditRutOrRecipe}
										/>
									)}
								</div>
								<h2 className='ph-tracking-detail-products-img-code-internal'>
									<strong className='ph-tracking-detail-products-img-code-internal-title'>
										Código interno:
									</strong>
									{product.code_internal}
								</h2>
								<h2 className='ph-tracking-detail-products-titles'>
									<img
										src={product.pharmacy_image}
										className='ph-tracking-detail-products-pharmacy-img'
										alt='producto'></img>
									<strong>Farmacias:</strong>{' '}
									<span className='ph-tracking-detail-products-subtitles'> {product.pharmacy}</span>
								</h2>
								<h2 className='ph-tracking-detail-products-titles'>
									<strong>Laboratorio:</strong>{' '}
									<span className='ph-tracking-detail-products-subtitles'>
										{' '}
										{product.laboratory}
									</span>
								</h2>
								<h2 className='ph-tracking-detail-products-titles'>
									<strong>Tipo de receta:</strong>{' '}
									<span className='ph-tracking-detail-products-subtitles'>
										{product.prescription_type}
									</span>
								</h2>
								<h2 className='ph-tracking-detail-products-titles'>
									<strong>Categoría:</strong>{' '}
									<span className='ph-tracking-detail-products-subtitles'>{product.category}</span>
								</h2>
								{product.unit_price && (
									<h2 className='ph-tracking-detail-products-titles'>
										<strong>Precio unitario:</strong>{' '}
										<span className='ph-tracking-detail-products-subtitles'>
											${product.unit_price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
										</span>
									</h2>
								)}
								{product.quantity && (
									<h2 className='ph-tracking-detail-products-titles'>
										<strong> Cantidad Comprada:</strong>{' '}
										<span className='ph-tracking-detail-products-subtitles'>
											{product.quantity}
										</span>
									</h2>
								)}
								<h2 className='ph-tracking-detail-products-titles'>
									<strong> Bioequivalencia:</strong>{' '}
									<span className='ph-tracking-detail-products-subtitles'>
										{product.bioequivalent}
									</span>
								</h2>
								<h2 className='ph-tracking-detail-products-titles'>
									<strong> Promoción:</strong>{' '}
									<span className='ph-tracking-detail-products-subtitles'>
										{product.promotions ? (
											<>
												{' '}
												{product.promotions.rules.tag}
												{product.promotions.rules.mecanic !== 'X % Descuento' &&
													` (${product.promotions?.rules.description})`}
											</>
										) : (
											product.filter_promotion
										)}
										{!!product.interface.promotions && (
											<img
												src={product.interface.promotions.main_img_promotion.default}
												className='ph-tracking-detail-products-img-promotion'
												alt='SALE'
											/>
										)}
									</span>
								</h2>
								{product.sub_total !== product.total && (
									<>
										<h2 className='ph-tracking-detail-products-titles'>
											<strong> Total:</strong>{' '}
											<span className='ph-tracking-detail-products-subtitles'>
												${product.total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
											</span>
										</h2>
									</>
								)}
								{product.sub_total !== product.price && (
									<>
										<h2 className='ph-tracking-detail-products-titles'>
											<strong>Precio por {product.quantity} unidades </strong>
											<span className='ph-tracking-detail-products-subtitles'>
												${product.sub_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
											</span>
										</h2>
									</>
								)}
								{product.promotions?.rules.mecanic === 'N x N' ? (
									<h2 className='ph-tracking-detail-products-titles'>
										<strong>Descuento</strong>
										<span className='ph-tracking-detail-products-subtitles'>
											$
											{product.valid_data_payment.discount
												.toString()
												.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
										</span>
									</h2>
								) : (
									<h2 className='ph-tracking-detail-products-titles'>
										<strong>Precio {product.quantity} unidad(es) con descuento:</strong>
										<span className='ph-tracking-detail-products-subtitles'>
											$
											{product.valid_data_payment?.total
												.toString()
												.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
										</span>
									</h2>
								)}
								{product.reverse && (
									<>
										<h2 className='ph-tracking-detail-products-titles'>
											<strong>Reversada:</strong>{' '}
											<span className='ph-tracking-detail-products-subtitles'>
												{' '}
												Reverso fue procesado
											</span>
										</h2>
										<h2 className='ph-tracking-detail-products-titles'>
											<strong>Cantidad reversada:</strong>
											<span className='ph-tracking-detail-products-subtitles'>
												{product.reverse_quantity}
											</span>
										</h2>
										<h2 className='ph-tracking-detail-products-titles'>
											<strong>Total por unidad reversada:</strong>
											<span className='ph-tracking-detail-products-titles'>
												$
												{product.reverse_unit_price
													.toString()
													.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
											</span>
										</h2>
										<h2 className='ph-tracking-detail-products-titles'>
											<strong>Total reversado:</strong>$
											<span className='ph-tracking-detail-products-subtitles'>
												{product.reverse_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}
											</span>
										</h2>
									</>
								)}
							</div>
						</div>
						<br />
						{product.validation_product && (
							<Alert
								className='ph-order-detail-products-collapse-info-alert'
								message={
									product.validation_product === 'RA'
										? 'Receta aprobada'
										: product.validation_product === 'RV'
										? 'Receta por verficiación'
										: 'Receta rechazada'
								}
								type={
									product.validation_product === 'RA'
										? 'success'
										: product.validation_product === 'RV'
										? 'warning'
										: 'error'
								}
								showIcon
							/>
						)}
						<br />
						{product.observation_reject_recipe && (
							<Collapse>
								<Collapse.Panel header='Historial de rechazos' key='1'>
									{product.observation_reject_recipe
										.slice(0)
										.reverse()
										.map((rejected, i) => (
											<React.Fragment key={i}>
												<h2 className='ph-tracking-detail-products-titles'>
													<strong>Responsable:</strong>{' '}
													<span className='ph-tracking-detail-products-subtitles'>
														{rejected.signature}
													</span>
												</h2>
												<h2 className='ph-tracking-detail-products-titles'>
													<strong>Motivo de rechazo:</strong>{' '}
													<span className='ph-tracking-detail-products-subtitles'>
														{rejected.description}
													</span>
												</h2>
												{product.observation_reject_recipe.length - 1 !== i && <hr />}
											</React.Fragment>
										))}
								</Collapse.Panel>
							</Collapse>
						)}
					</div>
				)
			})}
		</div>
	)
}
